// API functions for Skill Gap Assessment

import axiosClient from "../../api/AxiosClient";
import type {
  BenchmarkId,
  EmployeeProfile,
  ParsedProfile,
  QuestionResponse,
  RunResponse,
  SubmitResponse,
} from "./types";

export async function parseProfile(file: File): Promise<ParsedProfile> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosClient.post<ParsedProfile>(
    "/stream/skill-gap-assessment/parse-profile/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export async function parseProfileText(
  content: string,
  filename: string
): Promise<ParsedProfile> {
  const response = await axiosClient.post<ParsedProfile>(
    "/stream/skill-gap-assessment/parse-profile",
    {
      content,
      filename,
    }
  );
  return response.data;
}

export async function runAssessment(
  profile: ParsedProfile,
  benchmarkId: BenchmarkId
): Promise<RunResponse> {
  const response = await axiosClient.post<RunResponse>(
    "/stream/skill-gap-assessment/run",
    {
      profile,
      benchmark_id: benchmarkId,
    }
  );
  return response.data;
}

export async function submitResponses(
  workflowId: string,
  responses: QuestionResponse[]
): Promise<SubmitResponse> {
  const payload = responses.map(({ question_id, response, direction }) => ({
    question_id,
    response,
    ...(direction !== undefined ? { direction } : {}),
  }));
  const res = await axiosClient.post<SubmitResponse>(
    "/stream/skill-gap-assessment/submit",
    {
      workflow_id: workflowId,
      responses: payload,
    }
  );
  return res.data;
}
